// extracted by mini-css-extract-plugin
export default {"about":"About_about__b3XkW","btns":"About_btns__DHEGo","left":"About_left__mmU9A","manImg":"About_manImg__p0+WQ"};